export default __webpack_public_path__ + "static/media/darkPurplePulumi.bd4ad912.svg";